import React, { Component } from 'react'
import { connect } from 'react-redux'
import autoBind from 'auto-bind'
import { Translate } from 'react-localize-redux'
import Select from 'react-select/async'

import { searchUsersInRole } from '../../store/administration/InternalActions'
import Toaster from './Toaster'

/**
 * User selector container
 *
 * @class UserInRoleSelector
 * @extends {Component}
 */
class UserInRoleSelector extends Component {
	/**
	 *Creates an instance of UserInRoleSelector.
	 * @param {*} props
	 * @memberof UserInRoleSelector
	 */
	constructor(props) {
		super(props)
		autoBind(this)
		this.state = {
			isSearching: false,
			usersList: [],
			usersInRoleList: [],
			selectedUser: '',
		}
	}

	/**
	 * componentDidMount
	 */
	componentDidMount() {
		this.setState({ isSearching: true })
		this.props.searchUsers(this.props.role, this.props.supplierCode ? this.props.supplierCode : null).then(() => {
			let indexRole = this.props.usersByRole.findIndex((role) => {
				return Object.keys(role)[0] === this.props.role
			})
			if (indexRole >= 0) {
				let usersInRoleList = this.props.usersByRole[indexRole][this.props.role]
				this.setState({ usersInRoleList, isSearching: false })
			}
		})
	}

	/**
	 * React life-cycle
	 * select default option if prop.value is found in list
	 *
	 * @param {*} prevProps
	 * @param {*} prevState
	 * @memberof UserInRoleSelector
	 */
	componentDidUpdate(prevProps, prevState) {
		if (this.props.usersByRole !== prevProps.users) {
			let selectedUser = this.state.usersInRoleList.find((user) => {
				return user.user_name === this.props.value
			})
			if (selectedUser) {
				selectedUser = {
					label: selectedUser.name,
					value: selectedUser.user_name,
				}
				this.setState({ selectedUser })
			}
		}
	}

	/**
	 * handler to search options in suppliers list
	 *
	 * @param {*} query
	 * @returns
	 * @memberof SuppliersCompaniesSelector
	 */
	search(query) {
		this.setState({ isSearching: true })
		let filteredList = this.state.usersInRoleList.filter((user) => {
			return user.name.toLowerCase().includes(query.toLowerCase())
		})
		return Promise.resolve(filteredList)
	}

	/**
	 * Get the user matching with a query
	 *
	 * @param {*} query
	 * @returns
	 * @memberof UserInRoleSelector
	 */
	getUsers(query) {
		return this.search(query).then((usersList) => {
			this.setState({
				usersList,
				isSearching: false,
			})
			return usersList.map((user) => {
				return {
					label: user.name,
					value: user.user_name,
					// email: user.user_email
				}
			})
		})
	}

	/**
	 * Method to determine if input value has >=3 characters
	 * then isSearching is true and filter results
	 *
	 * @param {*} value
	 * @returns
	 * @memberof SuppliersCompaniesSelector
	 */
	onInputChange(value) {
		let isSearching = value.length >= 3
		this.setState({ isSearching })
		return value
	}

	/**
	 * On selec a user
	 *
	 * @param {*} option
	 * @memberof UserInRoleSelector
	 */
	onSelectedUserClick(option) {
		if (this.state.usersList) {
			let selectedUser = this.state.usersList.find((user) => {
				return user.user_name === option.value
			})
			if (selectedUser && this.props.onUserSelected) {
				this.setState(
					{
						selectedUser: {
							label: selectedUser.name,
							value: selectedUser.user_name,
						},
					},
					() => {
						this.props.onUserSelected(selectedUser)
					}
				)
			} else {
				this.setState({
					showToaster: true,
					toasterMessage: <Translate id='common.errorToSave' />,
					toasterVariant: 'error',
				})
			}
		}
	}

	/**
	 * Method to determine place holder message
	 *
	 * @returns
	 * @memberof SuppliersCompaniesSelector
	 */
	getPlaceholder() {
		let id = 'users.searchUser'
		if (this.state.isSearching || this.props.isLoadingUsers) id = 'common.loadingPleaseWait'

		return <Translate id={id} />
	}

	/**
	 *
	 *
	 * @returns
	 * @memberof UserInRoleSelector
	 */
	render() {
		return (
			<React.Fragment>
				<Select
					placeholder={this.getPlaceholder()}
					value={this.state.selectedUser}
					loadOptions={this.state.isSearching ? this.getUsers : ''}
					cacheOptions
					onChange={this.onSelectedUserClick}
					onInputChange={this.onInputChange}
					isDisabled={
						this.props.isLoadingUsers || this.props.isDisabled
							? this.props.isLoadingUsers || this.props.isDisabled
							: false
					}
					isLoading={this.props.isLoadingUsers || this.state.isSearching}
					styles={
						this.props.stylesFormMenu
							? this.props.stylesFormMenu
							: {
									menu: (base) => ({ ...base, zIndex: 50 }),
							  }
					}
				/>
				<Toaster
					message={this.state.toasterMessage}
					open={this.state.showToaster}
					variant={this.state.toasterVariant}
					onClose={() => {
						this.setState({ showToaster: false })
					}}
				/>
			</React.Fragment>
		)
	}
}

/**
 *  Defines the properties injecteded from the store to view container
 * @param {*} state
 */
function mapStateToProps(state) {
	return {
		isLoadingUsers: state.internalUsers.get('isLoadingUsers'),
		usersByRole: state.internalUsers.get('usersByRole') ? state.internalUsers.get('usersByRole').toJS() : null,
	}
}

/**
 * Defines the actions injectes to the component
 * @param {*} dispatch
 */
const mapDispatchToProps = (dispatch) => {
	return {
		searchUsers: (role, supplierCode) => {
			return dispatch(searchUsersInRole(role, supplierCode))
		},
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserInRoleSelector)
